const $ = require('jquery');

const floatingLabels = function () {
	$('.js-float-label .input, .js-float-label .textarea').on({
		focus() {
			$(this)
				.closest('.js-float-label')
				.addClass('is-active');
		},
		focusout() {
			if (!$(this).val()) {
				$(this)
					.closest('.js-float-label')
					.removeClass('is-active');
			}
		}
	});

	function checkAll() {
		$('.js-float-label:not(.is-active) .input, .js-float-label:not(.is-active) .textarea').each(function () {
			if ($(this).val()) {
				$(this)
					.closest('.js-float-label')
					.addClass('is-active');
			}
		});
	}

	// $(document).ready(function(){
	// $('.js-float .input, .js-float .textarea').change(function() {
	// 	checkAll();
	// });
	checkAll();
	// });
};

module.exports = floatingLabels;
